import { Component, computed, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { NavigationService } from '../../Navigation/Services/navigation.service';
import { MsgService } from '../../Shared/Services/msg.service';
import { AvBreadcrumbComponent } from '../../Shared/Components/av-breadcrumb/av-breadcrumb.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { isUUID } from '../../Shared/Utils/validation.utils';
import { ShowDeviceFacade } from '../../../Facades/Intune/show-device.facade';
import { AvLoadingItemComponent } from '../../Shared/Components/av-loading-item/av-loading-item.component';
import { DeviceActionsComponent } from '../Components/partials/device-actions/device-actions.component';
import { AuthService } from '../../Shared/Services/auth.service';
import { DEVICE_ACTION_PERMISSIONS } from '../../../Enums/permission.enum';

@Component({
  selector: 'app-device',
  imports: [RouterOutlet, MatIconModule, TranslateModule, AvBreadcrumbComponent, AvLoadingItemComponent, DeviceActionsComponent],
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.scss'],
})
export class DeviceComponent {
  private _navigationService = inject(NavigationService);
  private _facade = inject(ShowDeviceFacade);
  private _route = inject(ActivatedRoute);
  private _router = inject(Router);
  private _msgService = inject(MsgService);
  private _translate = inject(TranslateService);
  private _authService = inject(AuthService);

  readonly device = this._facade.device;

  private readonly _currentUser = toSignal(this._authService.currentUser$, { initialValue: null });

  readonly userHasDeviceActions = computed(() =>
    this._currentUser()?.hasPermission(DEVICE_ACTION_PERMISSIONS) ?? false
  );

  fetchDeviceEffect = effect(() => {
    this.fetchDevice();
    this.handleFetchError();
  });

  ngOnInit() {
    this._navigationService.setSecondaryView('devices/:id');
  }

  ngOnDestroy() {
    this._navigationService.clearSecondaryView();
  }

  private fetchDevice() {
    const deviceId = this._route.snapshot.paramMap.get('id');
    if (!deviceId || !isUUID(deviceId)) {
      this._translate.get('shared.general.errors.invalid_device_id').subscribe((msg) =>
        this._msgService.showSnackBar(msg, { type: 'error' })
      );
      this._router.navigate(['/devices']);
    }
    this._facade.setDeviceId(deviceId);
  }

  private handleFetchError() {
    if (this._facade.error()) {
      this._router.navigate(['/devices']);
    }
  }
}
